// extracted by mini-css-extract-plugin
module.exports = {"tc":"Tc_tc___bL8X"};